// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Importación nombrada
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "../components/LoadingSpinner"; // Importa el spinner

const ProtectedRoute = ({ roleAllowed, children }) => {
  const { token, role, refreshToken, loading } = useAuth(); // Obtener 'loading' del contexto
  console.log(
    "ProtectedRoute - Token:",
    token,
    "Role:",
    role,
    "Loading:",
    loading
  );

  if (loading) {
    // Mientras se inicializa la autenticación, mostrar el spinner
    return <LoadingSpinner />;
  }

  if (!token) {
    console.log("No token found. Redirecting to login.");
    return <Navigate to="/login" />;
  }

  // Verificar expiración del token
  try {
    const decoded = jwtDecode(token); // Usar jwtDecode correctamente importado
    console.log("ProtectedRoute - Decoded token:", decoded);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      console.log("Token expired. Attempting to refresh.");
      // Token expirado, intentar refrescar
      refreshToken().catch(() => {
        console.log("Failed to refresh token. Redirecting to login.");
        return <Navigate to="/login" />;
      });
    }
  } catch (err) {
    console.log("Error decoding token. Redirecting to login:", err);
    return <Navigate to="/login" />;
  }

  // Verificar roles
  if (roleAllowed) {
    const allowedRoles = Array.isArray(roleAllowed)
      ? roleAllowed
      : [roleAllowed];
    if (!allowedRoles.includes(role)) {
      console.log("User role not allowed. Redirecting to home.");
      return <Navigate to="/" />;
    }
  }

  return children;
};

export default ProtectedRoute;
